module.exports = __webpack_public_path__ + "static/media/YM59_4.bcecc11d.jpg";